"use client";

import ProfilePicture from "@/components/common/profile-picture/profile-picture";
import { formatImageUrl } from "@/lib/utils";
import { useAuth } from "@/providers/auth-provider";
import { useCreatePostModal, useModal } from "@/providers/modal-provider";
import { ModalType } from "@/types/modal-type";
import Skeleton from "react-loading-skeleton";

const FeedCreatePost = () => {
	const { openModal } = useModal();
	const { openCreatePostModal } = useCreatePostModal();
	const { user, isLoading, isLoggedIn } = useAuth();
	const profileImageUrl = user?.image || undefined;

	const handleClick = () => {
		if (!isLoggedIn) {
			openModal(ModalType.Auth);

			return;
		}
		openCreatePostModal();
	};

	return (
		<>
			<div className="rounded-lg bg-white p-4 shadow-sm">
				{isLoading ? (
					<div className="flex items-center justify-start gap-4">
						<Skeleton circle width={24} height={24} />
						<Skeleton width={200} height={24} />
						<Skeleton width={48} height={24} />
					</div>
				) : (
					<div className="space-y-4">
						<div className="flex flex-wrap items-center justify-start gap-4 lg:flex-nowrap lg:gap-1">
							<div
								onClick={handleClick}
								className="flex basis-full items-center justify-start gap-4"
							>
								<div>
									<ProfilePicture
										profilePictureUrl={formatImageUrl(profileImageUrl)}
										className={{ image: "h-11 w-11 rounded-full", container: "h-12 w-12" }}
									/>
								</div>

								<div className="flex h-12 w-full items-center justify-start self-stretch rounded-full bg-brand-primary/5 px-4 text-xs text-gray-400 outline-none">
									Share your thoughts
								</div>
							</div>

							<button
								type="button"
								onClick={handleClick}
								className="w-full self-stretch rounded-full bg-brand-primary px-6 py-2 text-center text-sm font-bold text-white lg:w-fit"
							>
								Create
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default FeedCreatePost;
